import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import CommentCard from "./CommentCard";
import { GetListReviews } from "../Business/Infrastructure/Business.presenter";

const commentsContainer = {
  background: "white",
  borderRadius: "10px",
  maxWidth: "709px",
  minHeight: "265px",
  width: "100%",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "18px 40px 18px" },
  marginTop: { md: "20px", lg: "20px" },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
  },
  commentsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconBag: { marginRight: "20px" },
  subtitle: {
    color: "#333333",
    fontWeight: 400,
    fontSize: "1.5rem",
    marginBottom: "10px",
  },
}));

export default function BusinessComments({ businessId }) {
  const classes = useStyles();
  const [commentsRender, setCommentsRender] = useState(false);
  const [comments, setComments] = useState({});

  useEffect(() => {
    if (businessId) {
      fetchDataComments(businessId);
    }
  }, [businessId]);

  async function fetchDataComments(id) {
    try {
      const info = await GetListReviews(id);
      setComments(info);
      if(info.length !== 0){
        setCommentsRender(true);
      }
    } catch (error) {
      console.log("Ha ocurrido un error, no hay comentarios.");
    }
  }

  return (
    <Box sx={commentsContainer}>
      <div className={classes.commentsHeader}>
        <div className={classes.header}>
          <h2>Comentarios</h2>
        </div>
      </div>
      <Divider sx={{ margin: "10px 0px" }} />
      <Box>
        {commentsRender ? (
          comments.map((value, index) =>
            index < 6 ? (
              <CommentCard
                key={index}
                id={index}
                businessId={businessId}
                name={value.evaluator_id.name}
                lastName={value.evaluator_id.last_name}
                comment={value.comment}
                stars={value.note}
              />
            ) : (
              <></>
            )
          )
        ) : (
          <>
            {" "}
            <p style={{minHeight: "200px"}} >Sin comentarios aún</p>{" "}
          </>
        )}
      </Box>
    </Box>
  );
}
